import Translations from "translations/types";

const TRANSITIONAL_CARE_KEY = "transitional_care" as const;

const TRANSITIONAL_CARE_STEPS = {
  IMPORT_DATA: "IMPORT_DATA",
  SAVE_CREATE_PDF: "SAVE_CREATE_PDF",
} as const;

export const TRANSITIONAL_CARE = {
  disablePageScroll: true,
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  key: TRANSITIONAL_CARE_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  steps: {
    [TRANSITIONAL_CARE_STEPS.IMPORT_DATA]: {
      intro: (t: Translations) => t.tours.transitionalCare.stepA.intro,
      key: TRANSITIONAL_CARE_STEPS.IMPORT_DATA,
      step: 1,
      title: (t: Translations) => t.tours.transitionalCare.stepA.title,
    },
    [TRANSITIONAL_CARE_STEPS.SAVE_CREATE_PDF]: {
      intro: (t: Translations) => t.tours.transitionalCare.stepB.intro,
      key: TRANSITIONAL_CARE_STEPS.SAVE_CREATE_PDF,
      step: 2,
      title: (t: Translations) => t.tours.transitionalCare.stepB.title,
    },
  },
} as const;
